import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  formImage: {
    justifySelf: 'center',
    width: '556px',
    marginRight: '-56px',
    ':hover': {
      ':not(#__unused__) div + div': {
        display: 'flex',
      },
    },
  },
  container: {
    marginRight: '56px',
    minHeight: '286px',
    position: 'relative',
    zIndex: 4,
  },
  dragContainer: {
    borderRadius: anatomy.borderRadiusM,
    backgroundImage: 'none',
    background: '#232A32',
    outline: `1px solid ${colors.accentBorder}`,
  },
  content: {
    padding: '107px 16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: anatomy['size-8'],
    borderRadius: anatomy.borderRadiusS,
    backgroundImage:
      "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23FFFFFF33' stroke-width='1' stroke-dasharray='4%2c 4' stroke-dashoffset='4' stroke-linecap='square'/%3e%3c/svg%3e\")",
    ':hover': {
      backgroundImage: 'none',
      backgroundColor: '#232A32',
      borderRadius: anatomy.borderRadiusM,
      outline: `1px solid ${colors.accentBorder}`,
      ':not(#__unused__) > button': {
        color: colors.secondaryBackground,
        ':not(#__unused__) svg path': {
          fill: colors.secondaryBackground,
        },
      },
    },
    ':not(#__unused__) > button': {
      margin: `${anatomy['size-8']} 0`,
      marginRight: '6px',
    },
  },
  contentPreview: {
    height: '88px',
    pointerEvents: 'none !important',
    boxSizing: 'content-box',
  },
  description: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
    color: palette['grey-500'],
  },
  errorContainer: {
    marginRight: '56px',
    display: 'flex',
    alignItems: 'center',
    height: '52px',
    borderBottom: `1px solid ${palette['lighted-10']}`,
    justifyContent: 'space-between',
  },
  errorContent: {
    display: 'flex',
    gap: anatomy['size-8'],
    alignItems: 'center',
  },
  errorText: {
    display: 'flex',
    flexDirection: 'column',
    color: colors.errorText,
  },
  errorTitle: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  errorDescription: {
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: '12px',
  },
  removeButton: {
    marginLeft: 'auto',
    cursor: 'pointer',
    position: 'relative',
    zIndex: 10,
    fill: `${colors.primaryInverseText}`,
    ':hover': {
      fill: `${colors.accentIcon} !important`,
      ':not(#__unused__)': {
        fill: `${colors.accentIcon} !important`,
      },
    },
  },
  moveButton: {
    display: 'none',
    position: 'absolute',
    right: anatomy['size-4'],
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    pointerEvents: 'none',
    ':not(#__unused__) button': {
      cursor: 'grab',
    },
  },
  actions: {
    display: 'none',
    gap: anatomy['size-8'],
    position: 'absolute',
    right: -8,
    top: '50%',
    transform: 'translateX(100%) translateY(-50%)',
  },
  removeBlockButton: {
    height: anatomy['size-24'],
    padding: anatomy['size-4'],
    background: colors.accentBackground,
    borderRadius: anatomy.borderRadiusXs,
    display: 'flex',
    ':hover': {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), ${colors.accentBackground}`,
    },
    ':not(#__unused__) svg path': {
      fill: `${palette['grey-950']} !important`,
    },
  },
  uploadButton: {
    height: anatomy['size-24'],
    width: anatomy['size-24'],
    padding: anatomy['size-4'],
    borderRadius: anatomy.borderRadiusXs,
    border: `1px solid ${palette['lighted-40']}`,
    display: 'flex',
    ':hover': {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), transparent`,
    },
    ':not(#__unused__) svg path': {
      fill: `${palette['greyWhite']} !important`,
    },
  },
  addButton: {
    width: '100%',
  },
  inputImage: {
    visibility: 'hidden',
    display: 'none',
  },
  imageContainer: {
    display: 'flex',
    height: '302px',
    border: `1px solid ${colors.accentBorder}`,
    borderRadius: anatomy.borderRadiusM,
    overflow: 'hidden',
  },
  imageContainerPreview: {
    border: 'none',
  },
  image: {
    objectFit: 'scale-down',
    display: 'flex',
    justifyItems: 'center',
    width: '100%',
    maxHeight: '100%',
  },
});
